import { loremIpsum, ILoremIpsumParams } from 'lorem-ipsum';

export type SeederTypes = 'absoluteUrl'
  | 'altText'
  | 'buttonText'
  | 'description'
  | 'firstName'
  | 'heading'
  | 'lastName'
  | 'linkText'
  | 'paragraph'
  | 'relativeUrl'
  | 'title';

export interface SeederProps extends ILoremIpsumParams {
  type?: SeederTypes;
}

const predefinedTypes = ({
  type,
}: SeederProps) => {
  switch (type) {
    case 'absoluteUrl':
      return 'https://lucid.app/lorem-ipsum';

    case 'altText':
      return loremIpsum({
        count: 3,
        format: 'plain',
        units: 'words'
      });

    case 'buttonText':
    case 'linkText':
      return `${loremIpsum({
        count: 1,
        format: 'plain',
        units: 'words'
      })} CTA`;

    case 'description':
      return loremIpsum({
        count: 7,
        format: 'plain',
        units: 'words'
      });

    case 'firstName':
      return 'FirstName';

    case 'heading':
      return loremIpsum({
        count: 3,
        format: 'plain',
        units: 'words'
      });

    case 'lastName':
      return 'LastName';

    case 'paragraph':
      return loremIpsum({
        count: 10,
        format: 'plain',
        paragraphLowerBound: 2,
        paragraphUpperBound: 5,
        sentenceLowerBound: 4,
        sentenceUpperBound: 7,
        units: 'paragraphs'
      });

    case 'relativeUrl':
      return '/lorem-ipsum';

    case 'title':
      return loremIpsum({
        count: 5,
        format: 'plain',
        units: 'words'
      });

    default:
      return 'Lorem Ipsum';
  }
};

const seeder = ({
  type,
  count,
  format,
  paragraphLowerBound,
  paragraphUpperBound,
  random,
  sentenceLowerBound,
  sentenceUpperBound,
  suffix,
  units,
  words
}: SeederProps): string => {
  try {
    let seederText = '';

    if (type) {
      seederText = predefinedTypes({ type });
    }

    if (!type) {
      const customSeeder = loremIpsum({
        count,
        format,
        paragraphLowerBound,
        paragraphUpperBound,
        random,
        sentenceLowerBound,
        sentenceUpperBound,
        suffix,
        units,
        words,
      });

      seederText = customSeeder;
    }

    return seederText;
  } catch (error) {
    throw new Error(`Seeder Error: ${error}`);
  }
};

export default seeder;
